import React, { useEffect, useMemo, useState } from 'react';
import api from '../../services/api';

const STATUS = {
  nieuw:     { label: 'Nieuw',         bg: '#dbeafe', fg: '#1e40af' },
  bekeken:   { label: 'Bekeken',       bg: '#ede9fe', fg: '#5b21b6' },
  gepland:   { label: 'Gepland',       bg: '#fef3c7', fg: '#92400e' },
  klaar:     { label: 'Gemaakt',       bg: '#d1fae5', fg: '#065f46' },
  afgewezen: { label: 'Niet haalbaar', bg: '#f3f4f6', fg: '#4b5563' },
};
const fmt = (d) => new Date(d).toLocaleDateString('nl-NL', { day: '2-digit', month: 'short', year: 'numeric' });
const card = { background: '#fff', borderRadius: 12, padding: '20px 24px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' };
const lbl = { fontSize: 11, letterSpacing: 1, textTransform: 'uppercase', color: '#6b7280', fontWeight: 600 };
const sel = { padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, background: '#fff' };
const th = { textAlign: 'left', padding: '10px 12px', fontSize: 11, letterSpacing: 1, textTransform: 'uppercase', color: '#6b7280', borderBottom: '1px solid #e5e7eb', fontWeight: 600 };
const td = { padding: '12px', borderBottom: '1px solid #f3f4f6', fontSize: 14, verticalAlign: 'top' };
const Badge = ({ s }) => { const c = STATUS[s] || STATUS.nieuw; return <span style={{ background: c.bg, color: c.fg, padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' }}>{c.label}</span>; };

export default function AdminIdeeen() {
  const [ideeen, setIdeeen] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fBedrijf, setFBedrijf] = useState('');
  const [fStatus, setFStatus] = useState('open');
  const [fCat, setFCat] = useState('');
  const [zoek, setZoek] = useState('');
  const [sel_, setSel] = useState(null);
  const [reactie, setReactie] = useState('');
  const [melding, setMelding] = useState('');

  const laden = async () => {
    try { const r = await api.get('/ideeen'); setIdeeen(r.data.ideeen || []); }
    catch { setMelding('Laden mislukt'); } finally { setLoading(false); }
  };
  useEffect(() => { laden(); }, []);

  const gekozen = ideeen.find((i) => i.id === sel_) || null;
  useEffect(() => { setReactie(gekozen?.reactie || ''); }, [sel_]); // eslint-disable-line

  const bedrijven = useMemo(() => [...new Set(ideeen.map((i) => i.bedrijf_naam).filter(Boolean))].sort(), [ideeen]);
  const cats = useMemo(() => [...new Set(ideeen.map((i) => i.categorie).filter(Boolean))].sort(), [ideeen]);
  const tel = (s) => ideeen.filter((i) => i.status === s).length;
  const stemmenTotaal = ideeen.reduce((a, i) => a + (i.stemmen || 0), 0);

  const lijst = ideeen.filter((i) =>
    (!fBedrijf || i.bedrijf_naam === fBedrijf) &&
    (fStatus === '' || (fStatus === 'open' ? ['nieuw', 'bekeken', 'gepland'].includes(i.status) : i.status === fStatus)) &&
    (!fCat || i.categorie === fCat) &&
    (!zoek || `${i.titel} ${i.omschrijving || ''} ${i.voornaam} ${i.achternaam}`.toLowerCase().includes(zoek.toLowerCase()))
  );

  const bijwerken = async (id, velden) => {
    try {
      await api.patch(`/ideeen/${id}`, velden);
      setIdeeen((l) => l.map((i) => (i.id === id ? { ...i, ...velden } : i)));
      setMelding('Opgeslagen'); setTimeout(() => setMelding(''), 1500);
    } catch { setMelding('Opslaan mislukt'); }
  };

  const kies = (i) => { setSel(i.id); if (i.status === 'nieuw') bijwerken(i.id, { status: 'bekeken' }); };

  return (
    <div style={{ padding: '32px 40px', maxWidth: 1400 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 24 }}>
        <h1 style={{ margin: 0, fontSize: 30 }}>💡 Ideeën</h1>
        <span style={{ color: '#6b7280', fontSize: 14 }}>{melding || `${ideeen.length} aanvragen van ${bedrijven.length} bedrijven`}</span>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        {[['Nieuw', tel('nieuw'), '#f59e0b', 'nieuw'], ['Gepland', tel('gepland'), '#3b82f6', 'gepland'], ['Gemaakt', tel('klaar'), '#10b981', 'klaar'], ['Stemmen totaal', stemmenTotaal, '#111827', null]].map(([t, n, c, f]) => (
          <div key={t} onClick={() => f && setFStatus(f)} style={{ ...card, cursor: f ? 'pointer' : 'default', borderLeft: `4px solid ${c}` }}>
            <div style={lbl}>{t}</div>
            <div style={{ fontSize: 34, fontWeight: 700, marginTop: 6, color: c }}>{n}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
        <input placeholder="Zoeken…" value={zoek} onChange={(e) => setZoek(e.target.value)} style={{ ...sel, flex: 1, minWidth: 200 }} />
        <select value={fBedrijf} onChange={(e) => setFBedrijf(e.target.value)} style={sel}>
          <option value="">Alle bedrijven</option>{bedrijven.map((b) => <option key={b}>{b}</option>)}
        </select>
        <select value={fStatus} onChange={(e) => setFStatus(e.target.value)} style={sel}>
          <option value="open">Open (nieuw · bekeken · gepland)</option>
          <option value="">Alle statussen</option>
          {Object.entries(STATUS).map(([k, v]) => <option key={k} value={k}>{v.label} ({tel(k)})</option>)}
        </select>
        <select value={fCat} onChange={(e) => setFCat(e.target.value)} style={sel}>
          <option value="">Alle categorieën</option>{cats.map((c) => <option key={c}>{c}</option>)}
        </select>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: gekozen ? '1fr 420px' : '1fr', gap: 16, alignItems: 'start' }}>
        <div style={{ ...card, padding: 0, overflow: 'hidden' }}>
          {loading ? <p style={{ padding: 24, color: '#6b7280' }}>Laden…</p>
          : lijst.length === 0 ? <p style={{ padding: 24, color: '#6b7280', textAlign: 'center' }}>Geen ideeën met deze filters.</p>
          : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr>
                <th style={{ ...th, width: 60, textAlign: 'center' }}>👍</th>
                <th style={th}>Idee</th><th style={th}>Bedrijf</th><th style={th}>Indiener</th>
                <th style={th}>Categorie</th><th style={th}>Datum</th><th style={th}>Status</th>
              </tr></thead>
              <tbody>
                {lijst.map((i) => (
                  <tr key={i.id} onClick={() => kies(i)} style={{ cursor: 'pointer', background: i.id === sel_ ? '#eff6ff' : i.status === 'nieuw' ? '#fffbeb' : '#fff' }}>
                    <td style={{ ...td, textAlign: 'center', fontWeight: 700, fontSize: 16 }}>{i.stemmen}</td>
                    <td style={td}>
                      <div style={{ fontWeight: 600 }}>{i.titel}</div>
                      {i.omschrijving && <div style={{ color: '#6b7280', fontSize: 13, marginTop: 2, maxWidth: 420, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{i.omschrijving}</div>}
                      {i.reactie && <div style={{ color: '#059669', fontSize: 12, marginTop: 4 }}>↳ {i.reactie}</div>}
                    </td>
                    <td style={td}><span style={{ background: '#111827', color: '#fff', padding: '2px 8px', borderRadius: 6, fontSize: 12, fontWeight: 600 }}>{i.bedrijf_naam || '—'}</span></td>
                    <td style={td}>{i.voornaam} {i.achternaam}</td>
                    <td style={td}>{i.categorie}</td>
                    <td style={{ ...td, whiteSpace: 'nowrap', color: '#6b7280' }}>{fmt(i.created_at)}</td>
                    <td style={td}><Badge s={i.status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {gekozen && (
          <div style={{ ...card, position: 'sticky', top: 24 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div style={lbl}>{gekozen.bedrijf_naam} · {gekozen.categorie}</div>
              <button onClick={() => setSel(null)} style={{ border: 'none', background: 'none', fontSize: 20, cursor: 'pointer', color: '#9ca3af', lineHeight: 1 }}>×</button>
            </div>
            <h2 style={{ margin: '6px 0 4px', fontSize: 20 }}>{gekozen.titel}</h2>
            <div style={{ color: '#6b7280', fontSize: 13 }}>{gekozen.voornaam} {gekozen.achternaam} · {fmt(gekozen.created_at)} · {gekozen.stemmen} stem{gekozen.stemmen === 1 ? '' : 'men'}</div>
            <p style={{ whiteSpace: 'pre-wrap', marginTop: 16, lineHeight: 1.5 }}>{gekozen.omschrijving || <i style={{ color: '#9ca3af' }}>Geen omschrijving</i>}</p>

            <div style={{ ...lbl, marginTop: 20 }}>Status</div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 8 }}>
              {Object.entries(STATUS).map(([k, v]) => (
                <button key={k} onClick={() => bijwerken(gekozen.id, { status: k })}
                  style={{ padding: '6px 12px', borderRadius: 20, fontSize: 13, fontWeight: 600, cursor: 'pointer',
                    border: `2px solid ${gekozen.status === k ? v.fg : 'transparent'}`, background: v.bg, color: v.fg }}>{v.label}</button>
              ))}
            </div>

            <div style={{ ...lbl, marginTop: 20 }}>Reactie naar de indiener</div>
            <textarea rows={4} value={reactie} onChange={(e) => setReactie(e.target.value)} placeholder="Wat gaat ermee gebeuren, en wanneer?"
              style={{ ...sel, width: '100%', marginTop: 8, resize: 'vertical', fontFamily: 'inherit' }} />
            <button onClick={() => bijwerken(gekozen.id, { reactie })}
              style={{ marginTop: 10, background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 18px', fontWeight: 600, cursor: 'pointer' }}>Reactie opslaan</button>
          </div>
        )}
      </div>
    </div>
  );
}
